import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export type CacheClearScope = "api" | "rate_limit" | "all";

export const ClearRuntimeCache = async (
  scopes: CacheClearScope[] = ["api"],
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/cache/clear`, { scopes });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to clear cache.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
